import { CorporationShopItemId } from '@game/enums';
import type {
  ClientCorporationEventLog,
  ClientCorporationJoinRequestor,
  ClientCorporationMember,
  ClientCorporationMissionRecord,
  ClientCorporationPermanentBuffPurchases,
  ClientCorporationPermanentBuffs,
  ClientCorporationRank,
  ClientInventoryItem,
  ClientPublicCorporation,
  ClientUserCorporationJoinRequest,
  CompleteCorporationMissionRecord,
  CorporationMissionBoardItem,
} from '@game/shared-types';

import type { InventoryFormType } from '../types/inventory.types';

export interface CorporationState {
  name: string;
  tag: string;
  influence: number;
  membershipLimit: number;
  inventoryLimit: number;
  permanentBuffs: ClientCorporationPermanentBuffs;
  permanentBuffPurchases: ClientCorporationPermanentBuffPurchases;
  rank: ClientCorporationRank;
  newMembersRankId: string;
  list: ClientPublicCorporation[];
  inventory: ClientInventoryItem[];
  sortedInventory: ClientInventoryItem[];
  inventoryModalToShow: InventoryFormType;
  inventorySelectedItem: ClientInventoryItem | null;
  publicDescription: string;
  publicDescriptionUpdatedAt: Date | null;
  privateDescription: string;
  privateDescriptionUpdatedAt: Date | null;
  members: ClientCorporationMember[]; // Members who are not invited
  joinRequestors: ClientCorporationJoinRequestor[];
  joinRequestsMade: ClientUserCorporationJoinRequest[];
  ranks: ClientCorporationRank[];
  eventLogs: ClientCorporationEventLog[];
  activeMissions: ClientCorporationMissionRecord[];
  completeMissions: ClientCorporationMissionRecord[];
  completeMissionsRecords: CompleteCorporationMissionRecord[];
  missionBoard: CorporationMissionBoardItem[];
}

export const corporationDefault: CorporationState = {
  name: '',
  tag: '',
  influence: 0,
  membershipLimit: 0,
  inventoryLimit: 0,
  permanentBuffs: {
    armourPercent: 0,
    craftingSuccessPercent: 0,
    damagePercent: 0,
  },
  permanentBuffPurchases: {
    [CorporationShopItemId.MembershipLimitIncrease]: 0,
    [CorporationShopItemId.InventoryLimitIncrease]: 0,
    [CorporationShopItemId.TempBuffDamage]: 0,
    [CorporationShopItemId.TempBuffArmour]: 0,
    [CorporationShopItemId.TempBuffCraftingSuccess]: 0,
    [CorporationShopItemId.TempBuffEnergyCap]: 0,
    [CorporationShopItemId.TempBuffSpiritCap]: 0,
    [CorporationShopItemId.GrantEnergyPack]: 0,
    [CorporationShopItemId.GrantSpiritPack]: 0,
    [CorporationShopItemId.PermBuffDamage]: 0,
    [CorporationShopItemId.PermBuffArmour]: 0,
    [CorporationShopItemId.PermBuffCraftingSuccess]: 0,
  },
  rank: {
    id: '',
    priority: 999,
    name: '',
    permissions: 0,
  },
  newMembersRankId: '',
  inventoryModalToShow: null,
  inventorySelectedItem: null,
  publicDescription: '',
  publicDescriptionUpdatedAt: null,
  privateDescription: '',
  privateDescriptionUpdatedAt: null,
  members: [],
  joinRequestors: [],
  joinRequestsMade: [],
  ranks: [],
  inventory: [],
  sortedInventory: [],
  list: [],
  eventLogs: [],
  activeMissions: [],
  completeMissions: [],
  completeMissionsRecords: [],
  missionBoard: [],
};
